import { IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import { useHistory } from 'react-router'
import { QuickActionsConstants } from '../store/quickActions.constants'
import './QuickActions.page.css'
import { useDispatch, useSelector } from 'react-redux'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { IOption } from '../../../common/common.types'
import { filterQuickActionButtons } from '../store/quickActions.actions'
import { useTranslation } from 'react-i18next'
import { chevronForward } from 'ionicons/icons'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'

const QuickActions: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const quickActionsAll = useSelector(getQuickActionsSelector)
  const { quickActions } = quickActionsAll

  const onQuickActionRowClick = (e: BaseSyntheticEvent, id: number | undefined) => {
    e.preventDefault()
    dispatch(filterQuickActionButtons(id))
    history.push(QuickActionsConstants.QUICK_ACTION_BUTTONS_ROUTE)
  }

  return (
    <IonPage>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonTitle>Quick Actions</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen color='light'>
        {quickActions && (
          <IonCard class='no-shadow'>
            {quickActions.map((action: IOption) => (
              <IonItem
                data-testid={`QuickAction${action.id}`}
                key={action.id}
                onClick={(e) => onQuickActionRowClick(e, action.id)}>
                <IonIcon icon={chevronForward} slot='end' color='medium' />
                <IonLabel>{action.name}</IonLabel>
              </IonItem>
            ))}
          </IonCard>
        )}
        {!quickActions.length && <h3>{t('quickActions.emptyLabel')}</h3>}
      </IonContent>
    </IonPage>
  )
}

export default QuickActions
